// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper__3e00S","error":"Modal_error__3nKe3","header":"Modal_header__3jdKb","close":"Modal_close__2EfR5","content-wrapper":"Modal_content-wrapper__2MH28"};